export default "__VITE_ASSET__DvgyDaR6__"